"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParent = void 0;
const excludedKeys = ['toString'];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isParent = (object) => {
    if (typeof object === 'function' || typeof object === 'object') {
        return (Object.keys(object).filter((key) => !excludedKeys.includes(key)).length >
            0);
    }
    return false;
};
exports.isParent = isParent;
//# sourceMappingURL=isParent.js.map